import React from 'react';

import { CORE_MENTEE_MODULE_STATUS_OPTIONS } from '@moduleManagement/data/coreMenteeModuleStatusOptions';
import Select from 'components/Select';

function MenteeModuleStatusSelect(props) {
  const _styles = {
    control: (styles, state) => ({
      ...styles,
      padding: 0,
    }),
  };

  return (
    <Select
      {...props}
      styles={_styles}
      options={CORE_MENTEE_MODULE_STATUS_OPTIONS}
    />
  );
}

export default MenteeModuleStatusSelect;
